import PropTypes from 'prop-types';
import * as React from 'react';
import { I18n } from 'react-redux-i18n-lite';

import CustomIcon from '../../../common/CustomIcon';
import Media from 'react-media';
import { MOBILE_MEDIA_QUERY } from '../../../../utils/mobileUtils';
import GradebookHelpButton from '../../mobile/GradebookHelpButton';

class GradesTasksTopBar extends React.Component {
  static propTypes = {
    studentsLength: PropTypes.number.isRequired,
    tasksLength: PropTypes.number.isRequired,
    moreTasks: PropTypes.func.isRequired,
    moreStudents: PropTypes.func.isRequired
  };

  render() {
    return (
      <div className="gradebook-topbar" style={{ marginLeft: 34, marginBottom: 32 }}>
        <div>
          <div className="gradebook-title">
            <CustomIcon color="#ccc" name="blank-paper-sheet" size={28} />
            {I18n.t('gradebook.scope.tasks')}:
          </div>
        </div>
        <Media query={MOBILE_MEDIA_QUERY}>{isMobile => isMobile && <GradebookHelpButton isTasks />}</Media>
      </div>
    );
  }
}

export default GradesTasksTopBar;
